const userTypes = {
  LANGUAGE_CHANGE_START: "LANGUAGE_CHANGE_START",
  LANGUAGE_CHANGE_SUCCESS: "LANGUAGE_CHANGE_SUCCESS",
  CLOSE_MODAL: "CLOSE_MODAL",
};

export default userTypes;
